import React, { useRef, useState, useEffect, useCallback } from "react";
import { FormatEmojii } from "../helper/FormatEmojii";

const EmojiList = ({ show, style, onClickOutside, onAddOrRemoveReaction }) => {
  const wrapperRef = useRef(null);
  const [emojisList, setEmojisList] = useState([]);

  const handleClickOutside = useCallback(
    (event) => {
      if (
        wrapperRef &&
        wrapperRef.current !== null &&
        !wrapperRef.current.contains(event.target)
      ) {
        onClickOutside?.();
      }
    },
    [onClickOutside]
  );

  useEffect(() => {
    const emojis = JSON.parse(localStorage.getItem("emojis"));
    setEmojisList(emojis);

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const spliceIntoChunks = (arr, chunkSize) => {
    const res = [];
    const arr2 = JSON.parse(localStorage.getItem("emojis"));
    while (arr2.length > 0) {
      const chunk = arr2.splice(0, chunkSize);
      res.push(chunk);
    }
    return res;
  };

  return show ? (
    <div
      className="emoji-list-main-container"
      style={style}
      ref={wrapperRef}
    >
      {spliceIntoChunks(emojisList, 6).map((chunks, idx1) => {
        return (
          <ul className="emoji-list-main-list">
            {chunks.length > 0 &&
              chunks.map((element, idx2) => {
                return (
                  <li className="emoji-list-main-item" key={idx2}>
                    <span
                      className="emoji-list-main-item-span"
                      onClick={() =>
                        onAddOrRemoveReaction(
                          element._id,
                          element.uniCode
                        )
                      }
                    >
                      {FormatEmojii(element.uniCode)}
                    </span>
                  </li>
                );
              })}
          </ul>
        );
      })}
    </div>
  ) : (
    <></>
  );
};

export default EmojiList;
